import {
  Button as MuiButton, ButtonProps, Menu, styled,
} from '@mui/material';
import React from 'react';
import ExpandMore from '../icons/ExpandMore';
import { DropdownAnchor, DropdownItem, useDropdownControls } from './Dropdown';

export const NewArrowDown = styled(ExpandMore)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
}));

export const Button = styled(MuiButton)(({ theme }) => ({
  borderRadius: 8,
  paddingLeft: theme.spacing(5),
  marginLeft: theme.spacing(4),
  marginRight: theme.spacing(4),
}));

interface NewActionBase {
  label: string;
}

interface NewActionClick extends NewActionBase {
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  href?: string;
}

interface NewActionHref extends NewActionBase {
  href: string;
  onClick?: NewActionClick['onClick'];
}

type NewAction = NewActionClick | NewActionHref;

export interface NewMenuProps extends Omit<ButtonProps, 'variant' | 'color'> {
  actions: NewAction[];
}

function NewMenu({ actions, ...props }: NewMenuProps) {
  const [anchorEl, handleOpen, handleClose] = useDropdownControls(props.onClick);

  return (
    <>
      <Button
        {...props}
        color="primary"
        variant="contained"
        onClick={handleOpen}
      >
        New
        {' '}
        <NewArrowDown />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        {actions.map((action) => (
          <DropdownItem key={action.label}>
            <DropdownAnchor href={action.href} onClick={action.onClick}>
              {action.label}
            </DropdownAnchor>
          </DropdownItem>
        ))}
      </Menu>
    </>
  );
}

export default React.memo(NewMenu);
